import { cn } from '@/lib/utils'
import { type HTMLAttributes, forwardRef } from 'react'

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'default' | 'lg' | 'full'
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, size = 'default', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'mx-auto w-full',
          {
            'max-w-7xl px-4 sm:px-6 lg:px-8': size === 'default',
            'max-w-6xl px-4 sm:px-6 lg:px-8': size === 'lg',
            'max-w-full px-4 sm:px-6 lg:px-8': size === 'full',
          },
          className
        )}
        {...props}
      />
    )
  }
)

Container.displayName = 'Container'
